import { render, staticRenderFns } from "./EnvolvidoProcesso.vue?vue&type=template&id=249550e8&"
import script from "./EnvolvidoProcesso.vue?vue&type=script&lang=js&"
export * from "./EnvolvidoProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports